

























































































































0
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
@Component({
  name: "login",
  components: {},
})
export default class LoginComponent extends Vue {
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  created() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
  }
  showWarning(message: string, type: string, time = 6000) {
    this.$buefy.toast.open({
      message: message,
      type: type,
      duration: time
    });
  }
  goToCreateAccountOptions() {
    this.$router.push("/create-account-options");
  }
  goToAccessOptions() {
    this.$router.push("/access-options");
  }
  goToAcceder() {
    this.$router.push("/acceder");
/*   }
  goToConsultaRapida() {
    this.$router.push("/consultaRapida"); */
  }
  goToAccederConTarjetaSolidaridad() {
    this.$router.push("/acceder-con-tarjeta-solidaridad");
  }
}
